import React, { useState, useEffect, useRef } from 'react';
import { Card, Button, Input, Bubble, Modal, notification, SearchBox } from 'tea-component';
import Abnormal from '@home/components/Abnormal';
import { useIntl, history, useSelector, useLocation } from 'umi';
import ImagePreview from '@intelligence/components/ImagePreview';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { trueDataFeedBackHistory } from '@home/services/home';
import { financeFormat } from '@home/utils/common';
import PublicTrueData, { IPublicTrueDataInstance } from '@/pages/intelligence/components/PublicTrueData';
import UserDefault from '@/pages/home/assets/img/common/user-default.svg';
import moment from 'moment';
import { toDateTypeMomentFormat } from '@/pages/intelligence/utils/common';
import AllModelData from '@/pages/intelligence/components/PublicTrueData/components/allData';
import TableContent from '@intelligence/components/PublicTrueData/components/TableContent';
import './PubilcTrueDataCard.scss';
import { delTrueDataFeedbackHistory } from '@/pages/intelligence/services/topcharts';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import { getGameInfoById } from '@intelligence/services/common';
import { iconSortFun } from '@intelligence/utils/common';
import FirstRow from '@intelligence/components/TableComponents/components/FirstRow';
import DatabrainBubbleTip from '@intelligence/components/TableComponents/components/FirstRow/DatabrainBubbleTip';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { scrollable } from 'tea-component/lib/table/addons';
import { gotoIntelligenceGame } from '@/pages/home/utils/utils';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { PageLogMes } from '@/pages/home/utils/buriedPointCfg';

const imageSize: Record<string, any> = {
  combine: {
    width: 30,
    height: 36,
  },
  pc: {
    width: 77,
    height: 36,
  },
  mobile: {
    width: 36,
    height: 36,
  },
  console: {
    width: 30,
    height: 36,
  },
};
interface PubilcTrueDataCardProps {
  publicTrueDataReportBtnLogKey?: string;
}

const PubilcTrueDataCard = (props: PubilcTrueDataCardProps) => {
  const { publicTrueDataReportBtnLogKey = 'homeTrueAllDataReport' } = props;
  const location = useLocation();
  // 新增真数反馈弹窗实例
  const publicTrueDataInstance = useRef<IPublicTrueDataInstance | null>(null);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [reports, setReports] = useState([]);
  const [noData, setNoData] = useState(false);
  const [entityType, setEntityType] = useState('combine');
  const [gameId, setGameId] = useState('');
  const [gameData, setGameData] = useState(null);
  const [selectGameName, setSelectGameName] = useState('');
  const [imageList, setImageList] = useState<string[]>([]);
  const { formatMessage } = useIntl(); // 中英切换方法
  const [allDataModel, setAllDataModel] = useState(false);
  const [tableParams, setTableParams] = useState({});
  // 游戏详情信息
  const [gameInfoRes, setGameInfoRes]: any = useState({});

  const [tableLoading, setTableLoading]: any = useState(false);
  // 搜索key值
  const [keyword, setKeyword] = useState('');

  // 表格对象
  const tableContent: any = useRef(null);
  // 编辑
  const [editFeedBackRecord, setEditFeedBackRecord]: any = useState({});
  const [isEditFeedBack, setIsEditFeedBack] = useState(false);
  const [outsideFeedBackVisible, setOutsideFeedBackVisible] = useState(false);
  const { userInfo } = useSelector((state: any) => ({
    userInfo: state?.home?.userInfo,
  }));

  const [deleteId, setDeleteId] = useState(0);
  const [visibleDelete, setVisibleDelete] = useState(false);

  // 图片预览
  const handleImagePreview = (imgs: string[]) => {
    setVisible(true);
    setImageList(imgs);
  };
  // 关闭图片预览
  const handleCloseImagePreview = () => {
    setVisible(false);
  };
  const handleClickGameName = (item: Record<any, any>) => {
    const type = item?.game_type || '';
    const urlMap: any = {
      combine: `/intelligence/topCharts/pcConsoleGames/gamesDetails/${item?.game_id}/overview`,
      mobile: `/intelligence/topCharts/mobileGames/gamesDetails/${item?.game_id}/overview`,
      console: `/intelligence/topCharts/consoleGames/gamesDetails/${item?.game_id}/overview`,
      pc: `/intelligence/topCharts/pcGames/gamesDetails/${item?.game_id}/overview`,
    };
    const url = urlMap[type];
    history.push(url);
  };
  const handleClickUrlIcon = (url: string) => {
    window.open(url, '_target');
  };
  const getMetricTimeCur = (tableItem: any) => {
    const formatValue = toDateTypeMomentFormat[tableItem.granularity] || 'YYYY-MM-DD';
    if (tableItem.metric_start_date === 'once') {
      return tableItem.metric_end_date || formatMessage({ id: 'dbh_home_true_data_once' }); //
    }
    if (tableItem.metric_start_date === '') {
      return '-';
    }
    if (tableItem.metric_start_date === tableItem.metric_end_date) {
      return moment(tableItem.metric_start_date).format(formatValue);
    }
    return `${moment(tableItem.metric_start_date).format(formatValue)}~${moment(tableItem.metric_end_date).format(
      formatValue,
    )}`;
  };
  const PublicTrueDataItem = (item: any) => {
    return (
      <div className={'dbh-true-data-item'}>
        <div className={'dbh-true-data-left-user-image'}>
          <img src={item?.anonymity ? UserDefault : item?.user_cover || UserDefault} />
        </div>
        <div className={'dbh-true-data-right-feedback-info'}>
          <div className={'dbh-true-data-user-name'}>
            <span>{item?.anonymity ? formatMessage({ id: 'dbi_EK_user' }) : item?.user_name}</span>
            <span style={{ marginLeft: '10px', display: 'inline-block' }}>
              {item.fill_time ? moment(item.fill_time).format('YYYY-MM-DD') : ''}
            </span>
          </div>
          <div className={'dbh-true-data-info-content'}>
            <img src={item?.game_cover} style={imageSize[item?.game_type]} />
            <div className={'dbh-true-data-info-title'}>
              <strong onClick={()=>handleClickGameName(item)} className={'dbh-true-data-strong'}>{item?.game_name}</strong>
              {getMetricTimeCur(item)}
              <strong className={'dbh-true-data-metric'}>{item?.metric_name}</strong>
              {financeFormat(item?.metric_value, 2, false, '')}
              {item?.source_image?.length ? (
                <SvgIcon
                  type={'image-preview'}
                  className={`dbi-table-icon-primary dbh-icon-need-cursor`}
                  onClick={() => handleImagePreview(item?.source_image)}
                />
              ) : null}
              {item?.source_type !== 'Expert Knowledge' && item?.url ? (
                <SvgIcon
                  type={'aigc-share'}
                  onClick={() => handleClickUrlIcon(item.url)}
                  className={`dbi-table-icon-primary dbh-icon-need-cursor`}
                />
              ) : null}
            </div>
            {item?.user_id === userInfo?.userid && (
              <div className={'dbh-edit-box'}>
                <Bubble dark arrowPointAtCenter content={formatMessage({ id: 'dbi_feedback_edit_public_true_data' })}>
                  <div
                    className={'dbh-edit-box-item'}
                    onClick={(e) => {
                      e?.stopPropagation();
                      e?.preventDefault();
                      handleClickEdit(item);
                    }}
                  >
                    <SvgIcon type="pencil-m" />
                  </div>
                </Bubble>
                <Bubble dark arrowPointAtCenter content={formatMessage({ id: 'Delete' })}>
                  <div
                    className={'dbh-edit-box-item'}
                    onClick={(e) => {
                      e?.stopPropagation();
                      e?.preventDefault();
                      handleClickDeleteIcon(item?.id);
                    }}
                  >
                    <SvgIcon type="clear-icon" />
                  </div>
                </Bubble>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // 打开link
  const handleClickLink = (url: string) => {
    // console.log('handleClickLink-url',url);
    window.open(url, '_blank');
  };

  // 编辑反馈
  const handleClickEdit = (record: any) => {
    if (record.game_type) {
      record = {
        ...record,
        entity_name: record.game_name,
        entity_type: record.game_type,
        anonymity: record.anonymity ? '0' : '1',
        metric_show_start_date: record.metric_start_date,
        metric_show_end_date: record.metric_end_date,
      };
    }
    const data = {
      metric_start_date: record.metric_show_start_date,
      metric_end_date: record.metric_show_end_date,
      ...record,
    };
    setEditFeedBackRecord(data);
    setIsEditFeedBack(true);
    setOutsideFeedBackVisible(true);
    // 更新列表
  };
  // 删除反馈
  const handleClickDeleteIcon = (id: any) => {
    setDeleteId(id);
    setVisibleDelete(true);
  };

  // 删除反馈
  const handleClickDelete = async () => {
    if (deleteId) {
      const params = {
        id: Number(deleteId),
      } as any;
      try {
        await delTrueDataFeedbackHistory(params);
        if (tableContent?.current) {
          tableContent?.current?.search();
        }
        // 更新列表
        onSuccess();
        notification.success({
          unique: true,
          description: formatMessage({
            id: 'dbi_success_opt',
            defaultMessage: 'Success Delete!',
          }),
          duration: 1000,
        });
      } catch (err) {
        notification.error({
          unique: true,
          description: formatMessage({
            id: 'dbi_feedback_delete_failed',
            defaultMessage: 'Failed Delete!',
          }),
          duration: 1000,
        });
      } finally {
      }
    }
    setVisibleDelete(false);
  };
  // 获取数据
  useEffect(() => {
    getFeedBackHistory();
  }, []);

  // Handle URL-triggered modal opening
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const action = searchParams.get('action');

    if (action === 'share-data') {
      publicTrueDataInstance.current?.open();

      // Clean up URL parameter
      const newSearchParams = new URLSearchParams(location.search);
      newSearchParams.delete('action');
      const newSearch = newSearchParams.toString();
      history.replace({
        pathname: location.pathname,
        search: newSearch ? `?${newSearch}` : '',
      });
    }
  }, [location.search]);
  const splitResData = (res: any) => {
    const result = res?.map((ele: any) => {
      return {
        ...ele,
        source_image: ele?.signature_source_image ? ele?.signature_source_image?.split('|') : [],
      };
    });
    return result;
  };
  const getFeedBackHistory = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await trueDataFeedBackHistory({
        page: 1,
        page_size: 4,
        b_fill_date: true,
        order: 'desc',
        order_metric: 'fill_time',
      });
      if (!res?.history?.length) {
        setNoData(true);
      } else {
        const result = splitResData(res?.history);
        setReports(result || []);
      }
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  // 贡献数据
  const PublicTureDataList = () => {
    return <div className={'dbh-true-data-content'}>{reports.map((ele) => PublicTrueDataItem(ele))}</div>;
  };
  const onSuccess = () => {
    getFeedBackHistory();
  };

  const onClickGame = (cvm: any) => {
    gotoIntelligenceGame(cvm.game_id, cvm.game_id.indexOf('c') === 0 ? 'combine' : cvm.entity_type, 'overview');
  };

  useEffect(() => {
    tableContent?.current?.search(1);
  }, [keyword]);
  const columns = [
    {
      key: 'entity_name',
      header: formatMessage({ id: 'dbi_top_gametitle' }),
      width: 180,
      align: 'left',
      sort: true,
      fixed: 'left', // (record: any) => <span>{record.entity_name || '-'}</span>,
      render: (cvm: any) => {
        // 获取entity的icon，排序先pc再console
        const order = ['mobile', 'pc', 'console'];
        const entityIcons: string[] = iconSortFun(Array.from(new Set(cvm?.entity_icon)), order);
        return (
          <div className={'dbi-table-inner-box'}>
            <FirstRow
              id={''}
              onClick={() => {
                onClickGame(cvm);
              }}
              cvm={{
                imgType: cvm?.entityType,
                img: gameInfoRes[cvm?.game_id]?.cover,
                gametitle: gameInfoRes[cvm?.game_id]?.entity_name || cvm?.entity_name,
                countryIcon: getCountryFlag(gameInfoRes[cvm?.game_id]?.country_abbre),
                text: <Bubble arrowPointAtCenter dark content={gameInfoRes[cvm?.game_id]?.publisher}>
                  <div className={'dbi_bubble_show dbi_table_public_data_all dbi_table_public_data_content'}>
                    <span>{gameInfoRes[cvm?.game_id]?.publisher}</span>
                  </div>
                </Bubble>,
                databrainIconTip: <DatabrainBubbleTip />,
                icon: null,
                entityIcon:
                  entityType === 'combine' && cvm?.entity_icon?.length ? (
                    <>
                      {entityIcons?.map((plat: string) => (
                        <a className="dbi-pcconsole-table-firstrow" key={cvm?.plat}>
                          <SvgIcon
                            className="dbi-pcconsole-table-entityicon"
                            type={plat === 'pc' ? 'monitor' : 'game'}
                          />
                        </a>
                      ))}
                    </>
                  ) : null,
              }}
            />
          </div>
        );
      },
    },
    {
      key: 'metric_date',
      header: formatMessage({ id: 'dbi_date' }),
      width: 170,
      sort: true,
      render: (record: any) => {
        const dataFormat: any = {
          daily: 'YYYY-MM-DD',
          weekly: 'YYYY-MM-DD',
          monthly: 'YYYY-MM',
          quarter: 'YYYY-MM',
          yearly: 'YYYY',
        };
        const str = dataFormat[record.granularity];
        return record?.metric_show_start_date !== 'once' ? (
          <span>
            {record?.metric_show_start_date
              ? `${record?.metric_show_start_date && moment(record?.metric_show_start_date).format(str)}~
            ${record?.metric_show_end_date && moment(record?.metric_show_end_date).format(str)}`
              : '-'}
          </span>
        ) : (
          record?.metric_show_end_date
        );
      },
    },
    {
      key: 'metric_name',
      header: formatMessage({ id: 'dbi_top_metric' }),
      width: 140,
      align: 'left',
      render: (record: any) => <span>{record.metric_name || '-'}</span>,
    },
    {
      key: 'metric_value',
      header: formatMessage({ id: 'dbi_data' }),
      width: 120,
      align: 'left',
      render: (record: any) => {
        if (!record.metric_value) {
          return '-';
        }
        return (
          <div className="dbi_table_public_data_all dbi_table_public_data_content">
            <Bubble arrowPointAtCenter dark content={record.metric_value}>
              <div className={'dbi_bubble_show dbi_table_public_data_all dbi_table_public_data_content'}>
                <span>{record.metric_value}</span>
              </div>
            </Bubble>
          </div>
        );
      },
    },
    {
      key: 'user_name',
      header: formatMessage({ id: 'dbi_feedback_contributor' }),
      width: 140,
      align: 'left',
      sort: true,
      render: (record: any) => (
        <span>{record?.anonymity === '1' ? formatMessage({ id: 'dbi_EK_user' }) : record.user_name || '-'}</span>
      ),
    },
    {
      key: 'fill_time',
      header: formatMessage({ id: 'dbi_feedback_contributor_time' }),
      width: 160,
      sort: true,
      // align: !isOverRightWidth && isEN ? 'right' : 'left',
      render: (record: any) => <span>{moment(record.fill_time).format('YYYY-MM-DD') || '-'}</span>,
    },
    {
      key: 'source_type',
      header: formatMessage({ id: 'dbi_feedback_source' }),
      width: 200,
      align: 'left',
      sort: true,
      render: (record: any) => {
        const imgList = record.signature_source_image ? record.signature_source_image?.split('|') : [];
        if (!record.source_type) {
          return '-';
        }
        const sourceTypeMap: any = {
          'Public Data': formatMessage({ id: 'dbi_feedback_public_data' }),
          'Expert Knowledge': formatMessage({ id: 'dbi_feedback_expert_knowledge' }),
          'Financial Reports': formatMessage({ id: 'dbi_feedback_financial_reports' }),
          Others: formatMessage({ id: 'dbi_feedback_public_others' }),
        };
        return (
          <div className="dbi_table_public_data_all">
            {sourceTypeMap[record.source_type]}
            {imgList?.length ? (
              <SvgIcon
                className="dbi-table-icon-image-preview"
                type="image-preview"
                onClick={(e) => {
                  e?.stopPropagation();
                  e?.preventDefault();
                  handleImagePreview(imgList);
                }}
              />
            ) : null}
          </div>
        );
      },
    },
    {
      key: 'url',
      header: formatMessage({ id: 'dbi_feedback_link' }),
      width: 120,
      align: 'left',
      render: (record: any) => {
        if (!record.url) {
          return '-';
        }
        return (
          <div>
            {record?.source_type === 'Expert Knowledge' ? (
              <div className="dbi_table_public_data_all dbi_table_public_data_content">
                <Bubble arrowPointAtCenter dark content={record.url}>
                  <div className={'dbi_bubble_show dbi_table_public_data_all dbi_table_public_data_content'}>
                    <span>{record.url}</span>
                  </div>
                </Bubble>
              </div>
            ) : (
              <SvgIcon
                type={'aigc-share'}
                className={`dbi-table-icon-link`}
                onClick={(e) => {
                  e?.stopPropagation();
                  e?.preventDefault();
                  handleClickLink(record.url);
                }}
              />
            )}
          </div>
        );
      },
    },

    {
      key: 'content',
      header: formatMessage({ id: 'dbi_feedback_note' }),
      width: 180,
      align: 'left',
      render: (record: any) => {
        if (!record.content) {
          return '-';
        }
        return (
          <div className="dbi_table_public_data_all dbi_table_public_data_content">
            <Bubble arrowPointAtCenter dark content={record.content}>
              <div className={'dbi_bubble_show dbi_table_public_data_all dbi_table_public_data_content'}>
                <span>{record.content}</span>
              </div>
            </Bubble>
          </div>
        );
      },
    },
    {
      key: 'options',
      header: formatMessage({ id: 'dbi_action' }),
      width: 120,
      align: 'left',
      render: (record: any) => (
        <div className="dbi_table_public_data_all dbi_table_public_data_options">
          {userInfo?.userid === record?.user_id ? (
            <>
              <Button
                type="link"
                onClick={(e) => {
                  e?.stopPropagation();
                  e?.preventDefault();
                  handleClickEdit(record);
                }}
              >
                {formatMessage({ id: 'Edit' })}
              </Button>
              <Button
                type="link"
                onClick={(e) => {
                  e?.stopPropagation();
                  e?.preventDefault();
                  handleClickDeleteIcon(record?.id);
                }}
              >
                {formatMessage({ id: 'Delete' })}
              </Button>
            </>
          ) : (
            '-'
          )}
        </div>
      ),
    },
  ];
  const preParams = (params?: any) => {
    setTableLoading(true);
    setTableParams({
      ...params,
      keyword,
      order: 'desc',
      api: '/api/v1/intelligence_pc/game/feedback_list?download=true',
      new_style_donwload_file_name: `DataBrain True Data${keyword ? '-' : ''}${keyword}`, // par key
      downloadConfigKey: 'trueAllDataDownloadExcel',
      file_format: 0,
      page_size: 100,
      select_top: 20000, // 最高数量
    });
    return { ...params, order: 'desc', keyword };
  };
  const lastResultData = (data?: any) => {
    setTableLoading(false);
    // 获取所有游戏id
    const ids = data.map((item: any) => item.game_id);
    getGameDetail(ids);
    return data;
  };
  // 获取游戏详情
  const getGameDetail = async (gameId: string) => {
    const params = {
      ids: gameId,
      entity_type: 'auto',
      custom_fields: [
        'cover',
        'entity_name',
        'country_abbre',
        'country_name_en',
        'parent_publisher',
        'developer_country_name_en',
        'developer_country_abbre',
        'developer_parent',
        'release_time',
        'publisher',
      ],
      level: 'custom',
    };
    const { data } = await getGameInfoById(params);
    setGameInfoRes(data);
  };
  const searchForm: any = {
    form: {
      hideLabel: true,
    },
    formList: [
      {
        key: 'search_key',
        label: 'search_key',
        render: () => {
          return (
            <SearchBox
              placeholder={formatMessage({ id: 'dbh_home_public_true_search_key' })}
              value={keyword}
              onChange={(value) => {
                setKeyword(value);
              }}
              onClear={() => {
                setKeyword('');
              }}
              style={{ width: '500px' }}
            />
          );
        },
      },
      {
        key: 'search_download',
        label: 'search_download',
        render: () => {
          return (
            <ExportTable
              downloadModalSize={820}
              entityType={entityType}
              // isDisableDownload={isLoading}
              downloadKey={'trueAllDataDownloadExcel'}
              // total={total}
              businessType={'trueAllDataDownloadExcel'}
              tableParams={tableParams}
              downloadLogConfigKey={'trueAllDataDownloadExcel'}
              useWebDownload={true}
              immediateDownload={true}
            />
          );
        },
      },
      // {
      //   key: 'search_download_detail',
      //   label: 'search_download_detail',
      //   render: () => {
      //     return <div className="search-download-detail">{formatMessage({ id: 'dbh_home_download_search_res' })}Download all data and search results</div>;
      //   },
      // },
    ],
  };

  const setAllDataModelState = (boolean: boolean) => {
    setAllDataModel(boolean);
    if (true) {
      buriedPointPage(PageLogMes.dataBrainHomeTrueDataDetail);
    }
  };

  return (
    <>
      <Card className={'home-card dbh-card-height dbh-true-data-page'}>
        <Card.Body
          title={<div className="home-table-title">{formatMessage({ id: 'dbh_home_public_true_data' })}</div>}
          operation={
            <Button
              onClick={() => {
                setAllDataModelState(true);
                setKeyword('');
                tableContent?.current?.initParams();
              }}
              type="link"
            >
              {formatMessage({ id: 'dbh_home_public_true_data_more' })}
            </Button>
          }
        >
          <Abnormal
            isLoading={loading}
            isError={error}
            isNoData={noData}
            style={{
              height: 395,
              color: '#444',
            }}
            component={<PublicTureDataList />}
          />
          <div className={'dbh-true-data-btn'}>
            <PublicTrueData
              ref={publicTrueDataInstance}
              publicTrueDataReportBtnLogKey={publicTrueDataReportBtnLogKey}
              handleSubmitSuccessFun={onSuccess}
              selectGameName={selectGameName}
              setSelectGameName={setSelectGameName}
              isNeedSearchGame={true}
              gameId={gameId}
              setGameIdValue={setGameId}
              match={{ ...props?.match, entityType }}
              entityType={entityType}
              setEntityTypeValue={setEntityType}
              gameData={gameData}
              setGameData={setGameData}
              setAllDataModel={setAllDataModelState}
            />
            <PublicTrueData
              gameId={editFeedBackRecord?.game_id}
              entityType={editFeedBackRecord?.entity_type}
              pageId={''}
              isEdit={isEditFeedBack}
              handleSubmitSuccessFun={
                tableContent?.current?.search
                  ? () => {
                    tableContent?.current?.search();
                    onSuccess();
                  }
                  : onSuccess
              }
              editRecord={editFeedBackRecord}
              outsideFeedBackVisible={outsideFeedBackVisible}
              isOutsideOpen={true}
              setOutsideFeedBackVisible={setOutsideFeedBackVisible}
              buttonNoShow={true}
            />
          </div>
          <AllModelData
            visible={allDataModel}
            setVisible={setAllDataModelState}
            width={1200}
            style={{ height: '758px' }}
            title={formatMessage({ id: 'dbh_home_public_true_all_data' })}
          >
            <TableContent
              className="dbh-home-public-true-table"
              ref={tableContent}
              url="/api/v1/intelligence_pc/game/feedback_list"
              searchForm={searchForm}
              columns={columns}
              sort={[{ by: 'fill_time', order: 'desc' }]}
              resultKey="list"
              recordKey="id"
              loading={tableLoading}
              preParams={preParams}
              lastResultData={lastResultData}
              // scroll={{ x: 'max-content', y: 55 * 5 }}
              // handerSearch={true}
              // immediately={false}
              addons={[
                // 支持表格滚动，高度超过 192 开始显示滚动条
                scrollable({
                  maxHeight: 600,
                  minWidth: 2000,
                }),
              ]}
            ></TableContent>
          </AllModelData>
        </Card.Body>
      </Card>
      {visibleDelete && (
        <Modal className="dbi-delete-group" visible={visibleDelete} size={500} onClose={() => setVisibleDelete(false)}>
          <Modal.Body>
            <div className="dbi-delete-group-title">
              {formatMessage({ id: 'dbi_feedback_you_sure_delete_true_data' })}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="primary"
              onClick={() => {
                handleClickDelete();
              }}
            >
              {formatMessage({ id: 'dbi_confirm' })}
            </Button>
            <Button
              type="weak"
              onClick={() => {
                setVisibleDelete(false);
              }}
            >
              {formatMessage({ id: 'dbi_cancel' })}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <ImagePreview visible={visible} imageList={imageList} onClose={handleCloseImagePreview} />
    </>
  );
};
export default PubilcTrueDataCard;
